export default __webpack_public_path__ + "static/media/PreviewOversizedTransparent.212f874c.png";